import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import PlayVideo from "../Play/PlayVideo";
import { Helmet } from "react-helmet";

import ContentModule from "../../modules/content_module";

import "../TextImageBlock/TextImageBlock.scss";

const StudenHub = ({Module, GQLPage}) => {

    const divRef = useRef();

    const htmlString = Module?.script_code ? Module?.script_code : "";

    useEffect(() => {
        const fragment = document.createRange().createContextualFragment(htmlString);
        divRef.current.append(fragment);
    }, []);


    return (
        <React.Fragment>
            <section className={`customer student_block`} id={"student_block"}>
                <Container>
                    <Row>
                        <Col>
                        <div class="studen-iframe-block 1">
                            <div className="customer-wrapper">
                                <div className={`video-content full_wdth`}>
                                    {Module?.title && <h3>{Module?.title}</h3>}
                                    
                                    {Module?.content && <ContentModule Content={Module?.content} /> }

                                    <div ref={divRef} className={Module?.script_code ? `event_info` : ""} />
                                </div>
                            </div>
                        </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </React.Fragment>
    );
};
export default StudenHub;